import { schema } from 'normalizr';
import { SCHEMA_TYPE_NOTIFICATION_SETTINGS } from '../constants/schemaTypes';

import userSchema from './user';
import orgSchema from './org';
import notificationChannel from './notificationChannel';

const notificationSettingSchema = new schema.Entity(SCHEMA_TYPE_NOTIFICATION_SETTINGS);

notificationSettingSchema.define({
  owner: userSchema,
  org: orgSchema,
  notification_channel_setting: notificationChannel,
});

export default notificationSettingSchema;
